import configs from "@src/configs";
export const LISTEN_ADDRESS = "/dns4/webrtc.ting.tube/tcp/443/wss/p2p-webrtc-star";
export const MULTI_ADDRESS_PREFIX = `${LISTEN_ADDRESS}/p2p/`;
export const libp2pIceServers = [...configs.webrtc.iceServers];
